import gql from 'graphql-tag';
import {
  FULL_TEMPLATE_REPORT_FIELDS,
} from '../schemas';

export const FETCH_TEMPLATE = gql`
  query getTemplate($id: ID!) {
    templateReport(id: $id) {
      id
      baseTemplateReportId
      reInspectionTemplateReportId
      name
      description
      displayName
      inspectionType
      noDeficienciesAllowed
      noLimitationsAllowed
    }
  }
`;

export const FETCH_DRAW_SOW_TEMPLATE = gql`
  query getDrawSowTemplate($inspectionId: ID!) {
    drawSowTemplateReport(inspectionId: $inspectionId) {
      id
      baseTemplateReportId
      reInspectionTemplateReportId
      name
      description
      displayName
      inspectionType
      noDeficienciesAllowed
      noLimitationsAllowed
    }
  }
`;

export const FETCH_TEMPLATE_AND_CATALOG_SYSTEMS_SUBSYSTEMS_INFORMATIONS = gql`
  ${FULL_TEMPLATE_REPORT_FIELDS}

  query getTemplate($id: ID!) {
    templateReport(id: $id) {
      ...FullTemplateReportFields
    }
  }
`;

export const FETCH_DRAW_SOW_TEMPLATE_AND_CATALOG_SYSTEMS_SUBSYSTEMS_INFORMATIONS = gql`
  ${FULL_TEMPLATE_REPORT_FIELDS}

  query getDrawSowTemplate($inspectionId: ID!) {
    drawSowTemplateReport(inspectionId: $inspectionId) {
      ...FullTemplateReportFields
    }
  }
`;
